export default __webpack_public_path__ + "static/media/Debaranjan Mishra, President, NIBSA SAlumni Association.7dbc2400.jpg";